import { Col, Row, Stack } from "react-bootstrap";
import { GenderFemale, GenderMale, HouseFill, PersonFill } from "react-bootstrap-icons";
import LoadingIndicator from "../LoadingIndicator";
import moment from "moment/min/moment-with-locales";

export default function ListenerRow({ item, virtualizer, virtualRow, sessionData, setSelectedListener }) {
    const loading = sessionData === "loading";

    return (
        <Row
            key={virtualRow.key}
            data-index={virtualRow?.index}
            ref={virtualizer?.measureElement}
            onClick={() => setSelectedListener(item)}
            style={{ transform: `translateY(${virtualRow?.start ?? 0}px)` }}
            className={`py-1 border-bottom w-100 position-absolute hoverable align-items-center`}>
            <Col xs={6} lg className="text-center">
                {moment(item.start_datetime).format("LT")} - {moment(item.end_datetime).format("LT")}
            </Col>
            <Col xs={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 0 }} xl={1}>
                <Row>
                    <Col xs={6} className="text-center">
                        {item.sex === "Male" && <GenderMale className="text-ra-alternative-blue" height={18} width={18} title="Male" />}
                        {item.sex === "Female" && <GenderFemale className="text-ra-brown" height={18} width={18} title="Female" />}
                    </Col>
                    <Col xs={6} className="text-center">
                        {item.age}
                    </Col>
                </Row>
            </Col>
            <Col xs={6} lg className="text-center">
                {item.region}
            </Col>
            <Col xs={6} lg={3} xl={2} className="text-center fs-8">
                <Row>
                    {item.personal_income && (
                        <Col xs={12} className="d-flex justify-content-center align-items-center">
                            <PersonFill title="Personal" height={16} width={16} className="me-1" />
                            {item.personal_income}
                        </Col>
                    )}
                    {item.household_income && (
                        <Col xs={12} className="d-flex justify-content-center align-items-center">
                            <HouseFill title="Household" height={16} width={16} className="me-1" />
                            <span>{item.household_income}</span>
                        </Col>
                    )}
                </Row>
            </Col>
            <Col xs={6} xl={3} className="text-center">
                {loading ? (
                    <LoadingIndicator width={39} showText={false} />
                ) : sessionData?.previous_session ? (
                    <Row>
                        <Col xs={12} className="fw-bold fs-7">
                            {sessionData.previous_session.station_name}
                        </Col>
                        <Col className=" fs-8">
                            <Stack direction="horizontal" gap={1} className=" justify-content-center">
                                <span>{moment(sessionData.previous_session.start_datetime).format("L")}</span>
                                <div className="vr"></div>
                                <span>{moment(sessionData.previous_session.start_datetime).format("LT")}</span>
                                <span>-</span>
                                <span>{moment(sessionData.previous_session.end_datetime).format("LT")}</span>
                            </Stack>
                        </Col>
                    </Row>
                ) : (
                    "-"
                )}
            </Col>
            <Col xs={6} xl={3} className="text-center">
                {loading ? (
                    <LoadingIndicator width={39} showText={false} />
                ) : sessionData?.next_session ? (
                    <Row>
                        <Col xs={12} className="fw-bold fs-7">
                            {sessionData.next_session.station_name}
                        </Col>
                        <Col className=" fs-8">
                            <Stack direction="horizontal" gap={1} className=" justify-content-center">
                                <span>{moment(sessionData.next_session.start_datetime).format("L")}</span>
                                <div className="vr"></div>
                                <span>{moment(sessionData.next_session.start_datetime).format("LT")}</span>
                                <span>-</span>
                                <span>{moment(sessionData.next_session.end_datetime).format("LT")}</span>
                            </Stack>
                        </Col>
                    </Row>
                ) : (
                    "-"
                )}
            </Col>
        </Row>
    );
}
